// src/utils.js
export const formatearPrecio = (valor) => {
  return new Intl.NumberFormat('es-CO', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0
  }).format(valor);
};

// Devuelve la fecha en formato YYYY-MM-DD usando el día local del navegador.
// OJO: no usar `date.toISOString().slice(0, 10)` para "la fecha de hoy" — toISOString
// convierte a UTC, y en Colombia (UTC-5) eso hace que desde las 7pm en adelante
// ya muestre el día siguiente aunque localmente todavía sea "hoy".
export const formatearFechaLocal = (date = new Date()) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Convierte un string "YYYY-MM-DD" (ej. el value de un <input type="date">) a un
// Date en medianoche LOCAL. OJO: no usar `new Date(str)` para esto — un string con
// ese formato lo interpreta como medianoche UTC, lo que en Colombia (UTC-5) lo
// corre al día anterior.
export const parsearFechaLocal = (str) => {
  const [year, month, day] = str.split('-').map(Number);
  return new Date(year, month - 1, day);
};

// Descarga un archivo de /media/ requiriendo autenticación JWT y devuelve
// una blob: URL local. El Content-Type real lo pone el backend
// (serve_media_autenticado), así que sirve tanto para PDFs como imágenes.
const obtenerBlobUrlAutenticado = async (urlOPath, api) => {
  // Extrae solo el path relativo: /media/facturas/file.pdf
  let path = urlOPath;
  if (path.startsWith('http')) {
    path = new URL(path).pathname;
  }
  // Convierte /media/facturas/file.pdf → /api/media/facturas/file.pdf
  const apiPath = path.replace(/^\/media\//, '/api/media/');
  const fullUrl = `${process.env.REACT_APP_API_URL}${apiPath}`;

  const response = await api.get(fullUrl, { responseType: 'blob' });
  return URL.createObjectURL(response.data);
};

// Abre un PDF de /media/ requiriendo autenticación JWT, en una pestaña nueva.
export const abrirPdfAutenticado = async (urlOPath, api) => {
  try {
    const blobUrl = await obtenerBlobUrlAutenticado(urlOPath, api);
    window.open(blobUrl, '_blank');
  } catch (err) {
    console.error('Error al abrir PDF:', err);
    alert('No se pudo abrir el PDF. Verifique su sesión.');
  }
};

// Descarga una imagen de /media/ requiriendo autenticación JWT y devuelve
// una blob: URL lista para usar como src de un <img>.
export const obtenerImagenAutenticada = async (urlOPath, api) => {
  return obtenerBlobUrlAutenticado(urlOPath, api);
};
